import { api } from "./api";

// Identifiant de session anonyme (sessionStorage : effacé à la fermeture de l'onglet,
// aucun cookie, aucune donnée personnelle, aucune adresse IP stockée). Conforme RGPD.
function sessionId() {
  try {
    let s = sessionStorage.getItem("dl_sid");
    if (!s) {
      s = Math.random().toString(36).slice(2) + Date.now().toString(36);
      sessionStorage.setItem("dl_sid", s);
    }
    return s;
  } catch {
    return "anon";
  }
}

// Mesure d'événement « fire-and-forget » : n'interrompt jamais l'expérience.
export function track(name, meta = {}) {
  try {
    api
      .post("/analytics/track", {
        name,
        path: typeof window !== "undefined" ? window.location.pathname : "",
        meta,
        session: sessionId(),
        ref: typeof document !== "undefined" ? document.referrer || "" : "",
      })
      .catch(() => {});
  } catch {
    /* ignore */
  }
}
